import { createAction, props } from '@ngrx/store';
import { DashboardData } from '../models/dashboard.models';

/**
 * Dashboard Actions
 */

// Load Dashboard Data
export const loadDashboard = createAction(
  '[Dashboard] Load Dashboard'
);

export const loadDashboardSuccess = createAction(
  '[Dashboard] Load Dashboard Success',
  props<{ data: DashboardData }>()
);

export const loadDashboardFailure = createAction(
  '[Dashboard] Load Dashboard Failure',
  props<{ error: string }>()
);

// Refresh Dashboard Data
export const refreshDashboard = createAction(
  '[Dashboard] Refresh Dashboard'
);

// Clear Dashboard Data
export const clearDashboard = createAction(
  '[Dashboard] Clear Dashboard'
);

// Update Last Refreshed Time
export const updateLastRefreshed = createAction(
  '[Dashboard] Update Last Refreshed',
  props<{ timestamp: Date }>()
);

